import { Outlet } from "react-router";
import { twJoin } from "tailwind-merge";

import { network } from "@/ui/common/config/network/btc";
import { Network } from "@/ui/common/types/network";
import "@/ui/globals.css";

import { Banner } from "./components/Banner/Banner";
import { CoStakingBanner } from "./components/CoStakingBanner";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";

export default function RootLayout() {
  return (
    <div
      className={twJoin(
        "snowfall-shell relative h-full min-h-svh w-full overflow-hidden",
        network === Network.MAINNET ? "main-app-mainnet" : "main-app-testnet",
      )}
    >
      <div className="snowfall-orb snowfall-orb-left" aria-hidden="true" />
      <div className="snowfall-orb snowfall-orb-right" aria-hidden="true" />

      <div className="relative z-10 flex min-h-svh flex-col">
        <Banner />
        <CoStakingBanner />
        <Header />

        <Outlet />

        <div className="mt-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
}
